import { Builder } from '@builder.io/react'

import RegulatoryFileBrowser from './regulatoryFileBrowser'

Builder.registerComponent(RegulatoryFileBrowser, {
  name: 'Regulatory File Browser',
  inputs: [
    {
      name: 'tabs',
      type: 'list',
      subFields: [
        {
          name: 'label',
          type: 'string',
          defaultValue: 'Tab',
          required: true,
        },
        {
          name: 'section',
          type: 'string',
          defaultValue: '',
          required: true,
          helperText: 'Backend file section key, e.g. market-data',
        },
        {
          name: 'filterable',
          type: 'boolean',
          defaultValue: false,
          helperText: 'Show the Year/Month filter (Market Data & Trade Data)',
        },
        {
          name: 'openInNewTab',
          type: 'boolean',
          defaultValue: false,
          helperText: 'Open files in a new tab instead of downloading (Product Certifications, Notices, agreements)',
        },
        {
          name: 'introSentence',
          type: 'longText',
          defaultValue: '',
          helperText: 'Optional sentence shown above a filterable list',
        },
      ],
    },
    {
      name: 'years',
      type: 'list',
      defaultValue: [{ year: '2026' }],
      subFields: [
        {
          name: 'year',
          type: 'string',
          defaultValue: '2026',
          required: true,
        },
      ],
      helperText: 'Years shown in the filter dropdown (newest first)',
    },
    {
      name: 'initialRows',
      type: 'number',
      defaultValue: 25,
      helperText: 'Rows shown before the Load More button',
    },
  ],
  noWrap: true,
})
